// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1TLKV","inner":"Footer_inner__45YL4"};